import { render, staticRenderFns } from "./t6.vue?vue&type=template&id=537b8e0f&"
import script from "./t6.vue?vue&type=script&lang=js&"
export * from "./t6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports